export const badge4AK1TranslationKeys: Record<string, string> = {
  TURNOVER_ACE: "turnoverAceString",
  PROFIT_ACE: "profitAceString",
  BREATHTAKING_ITEM_ACE: "breathtakingItemAceString",
  SUSTAINABLE_ACE: "sustainableAceString",
  KING: "kingString",
};
